import { X } from 'lucide-react'
import type { FC } from 'react'

import { Button } from '@/components/ui/button'

import type { CustomFilterShape } from './useFilters'

interface FilterButtonProps {
	filters: Array<CustomFilterShape>
	closeAndRemoveEmpty: () => void
}

export const FilterBox: FC<FilterButtonProps> = ({
	filters,
	closeAndRemoveEmpty,
}) => {
	return (
		<div className="flex justify-between items-center">
			{filters.length > 0 ? (
				<p className="text-muted-foreground text-sm">
					In this table, show records
				</p>
			) : (
				<p className="text-muted-foreground text-sm">
					No filter conditions are applied
				</p>
			)}

			<Button size="sm" variant="ghost" onClick={closeAndRemoveEmpty}>
				<X aria-hidden="false" aria-label="close filter dialog" />
			</Button>
		</div>
	)
}
